/* ============================================================
   LU - Arrastrar con el MOUSE los carriles horizontales (4-oct-2026, Sebas:
   «no se puede deslizar con el mouse ni los videos ni los minitextos: dificil
   su desplazamiento en PC»).
   Cualquier carril con [data-lu-drag] se puede arrastrar con el mouse como si
   fuera con el dedo: las piezas y sus chips, el slider de videos, las reseñas y
   los sellos del cajon. Delegado en document (un solo juego de oidos: sobrevive
   los re-renders del cajon) y SOLO para pointerType mouse: el dedo ya desliza
   solo y no se toca.
   Mientras se arrastra, la clase is-dragging apaga el snap y el scroll suave del
   carril (si no, el snap devuelve el carril a cada pixel y el smooth lo hace ir
   a tirones); al soltar, el navegador vuelve a encajar la tarjeta mas cercana.
   Si el mouse se movio mas de 6 px, el click que sigue se traga (si no, soltar
   sobre un chip o un video lo "tocaria"). Cero layout: solo escribe scrollLeft.
   ============================================================ */
(function () {
  if (window.__luDragScroll) return; window.__luDragScroll = true;
  var el = null, x0 = 0, s0 = 0, movio = false, id = null, tragar = false;
  function suelta() {
    if (!el) return;
    var e = el; el = null;
    e.classList.remove('is-dragging');
    try { if (id != null) e.releasePointerCapture(id); } catch (err) {}
    id = null;
    /* el click que viene pegado a este pointerup no cuenta; si no viene ninguno, la marca se borra sola */
    if (movio) { tragar = true; setTimeout(function () { tragar = false; }, 0); }
    movio = false;
  }
  document.addEventListener('pointerdown', function (ev) {
    if (ev.pointerType !== 'mouse' || ev.button !== 0) return;
    var t = ev.target && ev.target.closest ? ev.target.closest('[data-lu-drag]') : null;
    if (!t || t.scrollWidth <= t.clientWidth + 1) return;
    el = t; x0 = ev.clientX; s0 = t.scrollLeft; movio = false; id = ev.pointerId;
    t.classList.add('is-dragging');
    /* OJO: la captura del puntero se pide SOLO cuando el arrastre arranca (pointermove > 6 px). Si se pidiera aqui, el
       pointerup se re-dirigiria al carril y el click resultante caeria en el carril, no en el chip o el boton tocado:
       un click limpio dejaria de funcionar (cazado en banco). */
  }, true);
  document.addEventListener('pointermove', function (ev) {
    if (!el || ev.pointerType !== 'mouse') return;
    var dx = ev.clientX - x0;
    if (!movio && Math.abs(dx) > 6) { movio = true; try { el.setPointerCapture(id); } catch (err) {} }
    if (movio) el.scrollLeft = s0 - dx;
  }, { passive: true, capture: true });
  document.addEventListener('pointerup', suelta, true);
  document.addEventListener('pointercancel', suelta, true);
  /* el click que sigue a un arrastre no cuenta (capture: antes que cualquier oido delegado) */
  document.addEventListener('click', function (ev) {
    if (!tragar) return;
    tragar = false;
    ev.preventDefault(); ev.stopPropagation();
  }, true);
  /* arrastrar sobre una imagen o un video: que el navegador no inicie su propio drag del archivo */
  document.addEventListener('dragstart', function (ev) {
    if (ev.target && ev.target.closest && ev.target.closest('[data-lu-drag]')) ev.preventDefault();
  }, true);
})();
